module.exports = __webpack_public_path__ + "static/media/harvardLogo.35ef5e91.png";